import { ComponentStyleConfig } from "@chakra-ui/react";

const ModalTheme: ComponentStyleConfig = {
  baseStyle: {
    dialog: {
      overflow: "hidden",
    },
    body: {
      py: 0,
    },
    footer: {
      "& *": {
        // Don't cut off active button outline
        overflow: "visible !important",
      },
      pb: "24px",
    },
    header: {
      pt: "24px",
      "&&": {
        textStyle: "h4",
      },
    },
    closeButton: {
      top: "12px",
      right: "12px",
    },
  },
};

export default ModalTheme;
